module.exports = __webpack_public_path__ + "static/media/image_69.224d8acf.png";